import withRouter from '@utils/wrappers/WithRouter';
import FormUser from './UserForm';
import CrudPage from '@modules/cruds/CrudPage';
import * as yup from 'yup';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import { IUser } from '@ts/ui-models';
import { defaultConfigComponent } from './Users';
import { normalizeCEntity } from '@models/entity/Entity.normalizers';

const userSchema = yup.object().shape({
  login: yup.string().required().label('User Login ID'),
  firstName: yup.string().required().label('First Name'),
  familyName: yup.string().required().label('Family Name'),
  //ownerOrganizationId: yup.string().required().label('Employee of organization'),
  email: yup.string().required().label('Notifications Email'),
});

const UserPage = props => {
  const userId = props.transferPropsRoute.params.id;
  const dispatch = useAppDispatch();
  const appUser = useAppSelector(state => state.global.user);

  const updateUserRedux = async (values, options: { itemId: string; responseData: any }) => {
    const newUser = options.responseData;
    if (options.itemId === appUser?.id) {
      await dispatch(
        globalActions.updateGlobalState({
          key: 'user',
          value: { ...appUser, displayName: newUser.firstName + ' ' + newUser.familyName, person: newUser.userPersonData },
        })
      );
    }

    return;
  };

  return (
    <CrudPage
      key={'userPage'}
      configComponent={defaultConfigComponent}
      form={FormUser}
      validationSchema={userSchema}
      extraActionToDoAfterCorrectSubmit={updateUserRedux}
      normalize={normalizeCEntity<IUser>}
    />
  );
};

export default withRouter(UserPage);
